import { PRECISE_THRUST } from '../cards/attack/precise-thrust';
import { VENOMBLADE } from '../cards/attack/venomblade';
import { BRACE } from '../cards/defense/brace';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Rare tier: 3×3, 3 dice, greedy damage-max AI.
 * A fencer whose cuts carry venom and weakness. The greedy AI funds Thrust and
 * Venomblade *for the damage*, so the weaken + poison riders land reliably — the
 * only honest way to make a rare "control" enemy under greedy AI. Brace is
 * occasional flavour (rarely funded). The DoT outlasts the exchange. */
export const VIPER_DUELIST: EnemyTemplate = {
  id: 'viper-duelist',
  name: 'Viper Duelist',
  glyph: '⚜', // duellist's flourish
  tier: 'rare',
  hp: 24,
  loadout: [
    { card: VENOMBLADE, origin: { row: 0, col: 0 }, rotated: false },
    { card: PRECISE_THRUST, origin: { row: 0, col: 2 }, rotated: false },
    { card: BRACE, origin: { row: 2, col: 0 }, rotated: false },
  ],
  drops: { gold: 8 },
};
